import React, { ReactNode, useEffect, useState } from 'react';

import API from 'api';
import { GetAckWrapperResponse } from 'api/get/getCovid19AckWrapper';

interface COVID19AckTemplateContainerProps {
  children?: ReactNode;
}

const COVID19AckTemplateContainer = ({
  children,
}: COVID19AckTemplateContainerProps) => {
  const [ackWrapper, setAckWrapper] = useState<GetAckWrapperResponse>();

  useEffect(() => {
    (async () => {
      setAckWrapper(await API.GET.getCovid19AckWrapper());
    })();
  }, []);

  return (
    <>
      {ackWrapper && (
        <div className="ack-contents">
          <div dangerouslySetInnerHTML={{ __html: ackWrapper.header }}></div>
          {children}
          <div dangerouslySetInnerHTML={{ __html: ackWrapper.footer }}></div>
        </div>
      )}
    </>
  );
};

export default COVID19AckTemplateContainer;
